import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/auth/ProtectedRoute';
import OwnerLayout from './components/layout/OwnerLayout';

// Auth pages
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';

// Owner pages
import Dashboard from './pages/owner/Dashboard';
import AdvancedReport from './pages/owner/AdvancedReport';
import Businesses from './pages/owner/Businesses';
import Reporters from './pages/owner/Reporters';
import Entries from './pages/owner/Entries';
import Expenses from './pages/owner/Expenses';
import Settings from './pages/owner/Settings';

// Reporter pages
import ReporterEntry from './pages/reporter/ReporterEntry';

import './styles/global.css';

function OwnerRoute({ children }) {
  return (
    <ProtectedRoute role="OWNER">
      <OwnerLayout>{children}</OwnerLayout>
    </ProtectedRoute>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Auth */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />

          {/* Owner routes */}
          <Route path="/dashboard" element={
            <OwnerRoute><Dashboard /></OwnerRoute>
          } />
          <Route path="/advanced-report" element={
            <OwnerRoute><AdvancedReport /></OwnerRoute>
          } />
          <Route path="/businesses" element={
            <OwnerRoute><Businesses /></OwnerRoute>
          } />
          <Route path="/reporters" element={
            <OwnerRoute><Reporters /></OwnerRoute>
          } />
          <Route path="/entries" element={
            <OwnerRoute><Entries /></OwnerRoute>
          } />
          <Route path="/expenses" element={
            <OwnerRoute><Expenses /></OwnerRoute>
          } />
          <Route path="/settings" element={
            <OwnerRoute><Settings /></OwnerRoute>
          } />

          {/* Reporter routes */}
          <Route path="/report" element={
            <ProtectedRoute role="REPORTER"><ReporterEntry /></ProtectedRoute>
          } />

          {/* Default redirect */}
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
